<!-- <h1>Subscriptions</h1>

<div>
    <button href="javascript:void(0)" (click)="subscribe()">subscribe</button>
</div>

<br />

<button href="javascript:void(0)" data-cb-type="portal" (click)="manage()">Manage account</button> -->

<!-- <a href="javascript:void(0)" data-cb-type="checkout" data-cb-item-0="basic-INR-Monthly" data-cb-item-0-quantity="10" >subscribe</a>

<a href="javascript:void(0)" data-cb-type="portal" >Manage account</a> -->

<button type="button" (click)="manage()">Manage account</button>

<div class="animated fadeIn">
    <div class="animated fadeIn flex-row-fluid">
        <div class="container content-space-t-1 content-space-t-lg-2">
            <div class="row justify-content-center align-items-lg-center">
                <div class="col-lg-7 mb-7 mb-sm-10 mb-lg-0">
                    <div class="pe-lg-5">
                        <div class="mb-4">
                            <h1 class="display-4">Invest<br />in growth</h1>
                            <p class="fs-3">Hand-picked professionals and expertly crafted components, designed for any
                                kind of entrepreneur.</p>
                        </div>

                        <div class="row">
                            <div class="col-sm-5 col-lg-5">
                                <div class="position-relative">
                                    <!-- Card -->
                                    <div class="card card-shadow mb-3">
                                        <div class="card-body">
                                            <div class="text-center">
                                                <h4 class="card-title">Members</h4>
                                            </div>
                                            <div class="text-center mb-1">
                                                <h1 class="card-title">{{allAccountMemberships.length}}</h1>
                                            </div>
                                            <div class="d-grid">
                                                <button type="button" (click)="viewMembers()"
                                                    class="btn btn-primary btn-block">Manage</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-5 col-lg-5">
                                <div class="position-relative">
                                    <!-- Card -->
                                    <div class="card card-shadow mb-3">
                                        <div class="card-body">
                                            <div class="text-center">
                                                <h4 class="card-title">Licenses</h4>
                                            </div>
                                            <div class="text-center mb-1">
                                                <h1 class="card-title">{{allAccountMemberships.length}}</h1>
                                            </div>
                                            <div class="d-grid">
                                                <button type="button" (click)="viewMembers()"
                                                    class="btn btn-primary btn-block">Manage</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Row -->
                    </div>
                </div>
                <!-- End Col -->

                <div class="col-sm-9 col-lg-5">
                    <div class="position-relative">
                        <!-- Card -->
                        <div class="card card-shadow mb-3">
                            <div class="card-body">
                                <div class="text-center mb-5">
                                    <h4 class="card-title">Simple pricing</h4>
                                </div>

                                <!-- List -->
                                <ul class="list-unstyled list-py-1">
                                    <li>
                                        <!-- Radio Check -->
                                        <label
                                            class="form-check form-check-reverse form-check-select form-check-pinned-top-end"
                                            for="formCheckSelect1">
                                            <input type="radio" class="form-check-input" type="radio" value="monthly" 
                                            [(ngModel)]="planType" name="plan1"
                                            (change)="onItemChange($event.target.value)">
                                            <span class="form-check-label">
                                                <span class="fw-medium">Paid Monthly</span>
                                                <span class="d-block h4 mb-0"><i class="fa fa-inr"></i>&nbsp;800</span>
                                                <span class="d-block fs-6 text-muted">All the basics for starting a new
                                                    business</span>
                                            </span>
                                            <span class="form-check-stretched-bg"></span>
                                        </label>
                                        <!-- End Radio Check -->
                                    </li>

                                    <li>
                                        <!-- Radio Check -->
                                        <label
                                            class="form-check form-check-reverse form-check-select form-check-pinned-top-end"
                                            for="formCheckSelect2">
                                            <input type="radio" class="form-check-input" type="radio" value="six-months" 
                                            [(ngModel)]="planType" name="plan2"
                                            (change)="onItemChange($event.target.value)">
                                            <span class="form-check-label">
                                                <span class="fw-medium">Paid Half Yearly </span>
                                                    <span class="d-block h4 mb-0"><i class="fa fa-inr"></i>&nbsp;700</span>
                                                <span class="d-block fs-6 text-muted">Everything you need for a growing
                                                    business</span>
                                            </span>
                                            <span class="form-check-stretched-bg"></span>
                                        </label>
                                        <!-- End Radio Check -->
                                    </li>

                                    <li>
                                        <!-- Radio Check -->
                                        <label
                                            class="form-check form-check-reverse form-check-select form-check-pinned-top-end"
                                            for="formCheckSelect3">
                                            <input type="radio" class="form-check-input" type="radio" value="annual" 
                                            [(ngModel)]="planType" name="plan3"
                                            (change)="onItemChange($event.target.value)">
                                            <span class="form-check-label">
                                                <span class="fw-medium">Paid Annually</span>
                                                <span class="d-block h4 mb-0"><i class="fa fa-inr"></i>&nbsp;600</span>
                                                <span class="d-block fs-6 text-muted">Advanced features for scaling your
                                                    business</span>
                                            </span>
                                            <span class="form-check-stretched-bg"></span>
                                        </label>
                                        <!-- End Radio Check -->
                                    </li>
                                </ul>
                                <!-- End List -->

                                <div class="d-grid">
                                    <button type="button" (click)="subscribe()"
                                        class="btn btn-primary btn-block subscribe-button">Subscribe</button>
                                </div>
                            </div>
                        </div>
                        <!-- End Card -->
                    </div>

                    <div class="text-center">
                        <p class="fs-5 text-muted">Have Questions on Pricing? <a class="link link-pointer"
                                href="#">Contact sales</a></p>
                    </div>
                </div>
                <!-- End Col -->
            </div>
            <!-- End Row -->
        </div>
    </div>
</div>
